import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ResultData } from 'src/app/_models/ResultData';
import { DuplicatingService } from 'src/app/_services/duplicating.service';

import { FactService } from 'src/app/_services/fact.service';

@Component({
  selector: 'app-add-hoax-to-fact',
  templateUrl: './add-hoax-to-fact.component.html',
  styleUrls: ['./add-hoax-to-fact.component.css']
})
export class AddHoaxToFactComponent implements OnInit {
myForm:FormGroup

  dubFactBook:any=undefined
  mySubTopicList=[]
  idList:any=[]
  loading=false
  errorSaving=false
  isSaving=false
  fact:any
  serverFactId=0;
  constructor(private factService:FactService, private router:Router, private activatedRoute:ActivatedRoute,private duplicatorService:DuplicatingService) { }
  get f() {
    return this.myForm.controls
  }

  ngOnInit(): void {

 this.activatedRoute.params.subscribe(
  params=>{
    this.loading=true
    const dup =params['dup']
  this.serverFactId =params['server_fact_id']
    this.factService.getFactById(this.serverFactId).subscribe(
      {
        next:(data:ResultData)=>{
          this.fact=data.rs.data

        }
      })

    if(dup==0){
      this.initMainFormFresh()
      this.loading=false
    }else{
      this.duplicatorService.dupFactBook.subscribe(
        myDup=>{
          this.dubFactBook=myDup
          this.initMainFormDuplicate()
        }
      )

    }
  }
)


  }
  on_submit(){
    this.isSaving=true
    let dd=this.formatData(this.myForm.value.body,this.myForm.value.explanation, this.myForm.value.truth)
    this.factService.addHoaxesToFact(this.serverFactId,dd).subscribe(
      {
      next:(data:ResultData)=>{
        this.isSaving=false
        let d = data.rs.data
        if(d['server_fact_id']==0){
          this.errorSaving=true
        }else{
          this.router.navigate(['/admin/fact/show',d['server_fact_id']])
        }
      }
    ,error:(err)=>{
      console.error("error saving fact",err)
      this.isSaving=false
      this.errorSaving=true
    }})
  }
  formatData(body:string, explanation:string,truth:number){
    let data = new URLSearchParams();
    data.set('body', body);
    data.set('explanation', explanation);
    data.set('truth', truth.toString());
    const myIdList = this.evaluateId(this.mySubTopicList)
    for(let i=0; i < myIdList.length;i++){
      data.append('subTopics', myIdList[i].toString());
    }

    return data.toString()
  }






removeItemFromArray(server_subtopic_id:number){
  let index=0
  for( let i =0; i < this.mySubTopicList.length;i++){
    if(server_subtopic_id == this.mySubTopicList[i].id){
      index=i
      this.mySubTopicList.splice(index,1)
      break
  }
}
}

evaluateId(myList:any){
  let iid=[]
  for( let i =0; i < myList.length;i++){
    iid.push(myList[i].id)
  }
  return iid
}

initMainFormFresh(){
  this.myForm=new FormGroup({
    body: new FormControl("", [Validators.required,Validators.minLength(4)]),
    explanation: new FormControl("", [Validators.required,Validators.minLength(9)]),
    truth: new FormControl(0, [Validators.required])
  });
}
loadSubTopics(){
  this.factService.getSubTopicByFact(this.dubFactBook.server_fact_id).subscribe(
    {
      next:(data:ResultData)=>{
        this.mySubTopicList=data.rs.data
        this.loading=false
       }
    }
  )
  }
initMainFormDuplicate(){

  this.myForm=new FormGroup({
    body: new FormControl(this.dubFactBook.body, [Validators.required,Validators.minLength(4)]),
    explanation: new FormControl(this.dubFactBook.explanation, [Validators.required,Validators.minLength(9)]),
    truth: new FormControl(this.dubFactBook.truth? 1:0, [Validators.required]),
  });
}
}
